export const SemaphoreGroupPCDTypeName = "semaphore-group-signal";
export class SemaphoreGroupPCD {
    constructor(id, claim, proof) {
        this.type = SemaphoreGroupPCDTypeName;
        this.id = id;
        this.claim = claim;
        this.proof = proof;
    }
}
